import { Text as ChakraText, TextProps } from '@chakra-ui/react';

const Text = ({ children, as = 'p', ...props }: TextProps) => (
  <ChakraText as={as} {...props}>
    {children}
  </ChakraText>
);

export default Text;
